import { useQuery } from "@tanstack/react-query"
import { getKpiMetricDefinitions } from "api/employeeKpiApi"

export const useKpiMetricDefinitions = () => {
  return useQuery({
    queryKey: ["kpi-metric-definitions"],
    queryFn: getKpiMetricDefinitions,
    staleTime: 1000 * 60 * 5,
  })
}
